var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 20,
    cy: 20,
    r: 20,
    fill: props.color
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#cashPayment)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3 19.0222C18.03 18.4978 17.3 17.9556 17.3 17.1111C17.3 16.1422 18.31 15.4667 20 15.4667C21.42 15.4667 22.13 15.9467 22.39 16.7111C22.51 17.0667 22.84 17.3333 23.26 17.3333H23.56C24.22 17.3333 24.69 16.7556 24.46 16.2044C24.04 15.1556 23.06 14.2844 21.5 13.9467V13.3333C21.5 12.5956 20.83 12 20 12C19.17 12 18.5 12.5956 18.5 13.3333V13.92C16.56 14.2933 15 15.4133 15 17.1289C15 19.1822 16.91 20.2044 19.7 20.8C22.2 21.3333 22.7 22.1156 22.7 22.9422C22.7 23.5556 22.21 24.5333 20 24.5333C18.35 24.5333 17.5 24.0089 17.17 23.2622C17.02 22.9156 16.68 22.6667 16.27 22.6667H15.99C15.32 22.6667 14.85 23.2711 15.1 23.8222C15.67 25.0578 17 25.7867 18.5 26.0711V26.6667C18.5 27.4044 19.17 28 20 28C20.83 28 21.5 27.4044 21.5 26.6667V26.0889C23.45 25.76 25 24.7556 25 22.9333C25 20.4089 22.57 19.5467 20.3 19.0222Z",
    fill: "#295BB7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cashPayment"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment);
export default __webpack_public_path__ + "static/media/cashPayment.8e49c907cfcf253ba259439b838929d0.svg";
export { ForwardRef as ReactComponent };